<template>
  <div
    class="relative flex justify-between pb-2 px-8 border-b border-neutral-400 dark:border-neutral-600"
  >
    <span class="my-auto font-medium">
      {{ month }}
    </span>
    <span class="my-auto text-xs text-neutral-600 dark:text-neutral-400">
      {{ year }}
    </span>
    <div class="absolute flex justify-between w-full left-0 -top-1">
      <NamiButton
        buttonType="secondary"
        text
        small
        pill
        no-waves
        :icon="IconChevronLeft"
        @buttonClick="$emit('prev')"
      />
      <NamiButton
        buttonType="secondary"
        text
        small
        pill
        no-waves
        :icon="IconChevronRight"
        @buttonClick="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-vue";

defineProps<{
  month: string;
  year: string | number;
}>();

defineEmits<{
  (e: "next"): void;
  (e: "prev"): void;
}>();
</script>
